import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/app/auth/context";

import { Card } from "@/components/ui/Card";
import { PageHeader } from "@/components/ui/PageHeader";
import { ArchiveEmptyState } from "@/features/archive/ArchiveEmptyState";
import { archiveSummaryQuery } from "@/lib/api";
import { meApi } from "@/lib/tickets-api";

import { ArchiveSummaryCard } from "./ArchiveSummaryCard";
import { SystemStatusCard } from "./SystemStatusCard";
import { TicketShortcutsCard } from "./TicketShortcutsCard";

export function DashboardPage() {
  const { t } = useTranslation();
  const summary = useQuery(archiveSummaryQuery);
  const { can } = useAuth();
  return (
    <>
      <PageHeader title={t("dashboard.title")} />
      <div className="grid items-start gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          {summary.data && summary.data.tickets > 0 ? (
            <ArchiveSummaryCard summary={summary.data} />
          ) : (
            summary.data && (
              <Card>
                <ArchiveEmptyState />
              </Card>
            )
          )}
        </div>
        <SystemStatusCard />
        {can("archive.browse") && (
          <>
            <TicketShortcutsCard
              id="favorites-title"
              title={t("dashboard.favorites")}
              empty={t("dashboard.favoritesEmpty")}
              queryKey={["me", "favorites"]}
              queryFn={meApi.favorites}
            />
            <TicketShortcutsCard
              id="recent-title"
              title={t("dashboard.recent")}
              empty={t("dashboard.recentEmpty")}
              queryKey={["me", "recent"]}
              queryFn={meApi.recent}
            />
          </>
        )}
      </div>
    </>
  );
}
